import { Button } from "@shared/ui/Button";
import { Flex, Typography } from "antd";
import { AlertTriangle } from "lucide-react";
import styles from "../styles.module.scss";

const { Text } = Typography;

interface RemovePricingBodyProps {
  eligibleCount: number;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function RemovePricingBody({
  eligibleCount,
  isLoading,
  onClose,
  onConfirm,
}: RemovePricingBodyProps) {
  const isDisabled = eligibleCount === 0;

  return (
    <div className={styles.removeBody}>
      <div className={styles.warningBanner}>
        <AlertTriangle size={18} className={styles.warningIcon} />
        <div>
          This removes the assigned pricing POC for the selected creators.
          Saved commercials and negotiation history stay on the row — only the
          owning POC is cleared.
        </div>
      </div>

      <p className={styles.removeNote}>
        <Text strong>{eligibleCount}</Text> creator
        {eligibleCount !== 1 ? "s" : ""} will be de-allocated from their pricing
        POC. You can send them to pricing again later if needed.
      </p>

      <Flex justify="end" gap={12}>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          type="primary"
          danger
          loading={isLoading}
          disabled={isDisabled}
          onClick={onConfirm}
        >
          Remove pricing POC
        </Button>
      </Flex>
    </div>
  );
}
